import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { UserService } from '../../../shared/services/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { filter } from "rxjs/operators";
import { AuthGuard } from "../../../shared/guard";

declare var $: any;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnDestroy {
    token: any;
    public pushRightClass: string;
    totalNotification: any;
    person: any;
    distroy: any;
    isSwitchUser: any;
    oneTime = 1;
    constructor(public router: Router,
        private toastr: ToastrService,
        private authGuard: AuthGuard,
        private userService: UserService,
        private cdr: ChangeDetectorRef) {
        this.router.events.pipe(
            filter((event: RouterEvent) => event instanceof NavigationEnd)
        ).subscribe((data: any) => {
            this.token = localStorage.getItem('token');
            this.person = JSON.parse(localStorage.getItem('person'));
            this.isSwitchUser = localStorage.getItem('isSwitchUser');
            if (this.isSwitchUser === 'true') {
                if (this.oneTime === 1) {
                    this.getNotification();
                    this.oneTime = 2;
                }
                $(".switchUserHead").addClass("switchUserHeader");
            } else {
                this.oneTime = 1;
                $(".switchUserHead").removeClass("switchUserHeader");
            }
            if (data.url === '/report') {
                if (this.person.role === 'Licensing Department') {
                    this.router.navigate(['/report/rider-report']);
                }
                if (this.person.role === 'Accounts') {
                    this.router.navigate(['/report/create-journal-voucher']);
                }
            }
        });

        this.router.events.subscribe(val => {
            if (
                val instanceof NavigationEnd &&
                window.innerWidth <= 992 &&
                this.isToggled()
            ) {
                this.toggleSidebar();
            }
        });
    }
    isToggled(): boolean {
        const dom: Element = document.querySelector('body');
        return dom.classList.contains(this.pushRightClass);
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle(this.pushRightClass);
    }

    ngOnInit() {
        this.pushRightClass = 'push-right';
        this.getDashboardData();
        if (this.isSwitchUser === 'false') {
            this.getNotification();
        }
        this.distroy = window.setInterval(() => {
            this.getNotification();
        }, 10000);
    }

    getDashboardData() {
        this.userService.getUserDashboardDataService(this.token).subscribe((data: any) => {
            this.token = localStorage.getItem('token');
            this.person = data;
            this.isSwitchUser = localStorage.getItem('isSwitchUser');
        }, error => {
            if (error.status === 200) {
                return;
            } else if (error.status === 401) {
                localStorage.clear();
                this.toastr.success(error.error.message);
                this.router.navigate(['/signout']);
            } else {
                this.toastr.error(error.message);
            }
        });
    }

    ngOnDestroy() {
        if (this.distroy) {
            clearInterval(this.distroy);
        }
    }

    onLoggedout() {
        localStorage.removeItem('token');
        $('#logoutModel').modal('hide');
        this.toastr.success('Logout Successfully');
        this.router.navigate(['/signout']);
        this.authGuard.canActivate();
    }

    exitSwitchAccountData() {
        localStorage.removeItem('concussion');
        localStorage.removeItem('data-protection');
        localStorage.removeItem('declaration');
        localStorage.removeItem('experience');
        localStorage.removeItem('facilities');
        localStorage.removeItem('fiscal');
        localStorage.removeItem('fitAndProperPerson');
        localStorage.removeItem('fixtures');
        localStorage.removeItem('insurance');
        localStorage.removeItem('medicalQuestions');
        localStorage.removeItem('personnel');
        localStorage.removeItem('details');
        localStorage.removeItem('principalyard');
        localStorage.removeItem('additionalyard');
        localStorage.removeItem('assistantTrainer');
        localStorage.removeItem("numberOfAssistantTrainerAllow")
        localStorage.removeItem('authorisedReps');
        localStorage.removeItem('sbsagreement');
        localStorage.removeItem('messagingservice');
        localStorage.removeItem('employeeCard');
        localStorage.removeItem('tab');
        // trainer first time 
        localStorage.removeItem('prospectivOwners');
        localStorage.removeItem('horses');
        localStorage.removeItem('employment');
        localStorage.removeItem('insurance');
        localStorage.removeItem('trainer-personnel');
        localStorage.removeItem('trainer-experience');
        localStorage.removeItem('corporate');
        const licenceDepartmentToken = localStorage.getItem('LicenceDepartmentToken');
        const licenceDepartmentPerson = localStorage.getItem('LicenceDepartmentPerson');
        localStorage.setItem('token', licenceDepartmentToken);
        localStorage.setItem('person', licenceDepartmentPerson);
        localStorage.setItem('isSwitchUser', 'false');
        $('#exitSwitchUserModel').modal('hide');
        localStorage.removeItem('LicenceDepartmentToken');
        localStorage.removeItem('LicenceDepartmentPerson');
        localStorage.removeItem('currentApplicationId');

        this.router.navigate(['/licence-holder/impersonate-user']);
        this.toastr.success('Back to Account Successfully');
        this.getNotification();
    }

    getNotification() {
        var isActive = this.authGuard.canActivate();
        if (isActive) {
            this.userService.getNotificationCountService(localStorage.getItem('token')).subscribe((data: any) => {
                this.totalNotification = data;
                this.cdr.detectChanges();
            }, error => {
                clearInterval(this.distroy);
                if (error.status === 200) {
                    return;
                } else if (error.status === 401) {
                    this.onLoggedout();
                    this.toastr.success(error.error.message);
                    this.router.navigate(['/signout']);
                } else {
                    this.toastr.error(error.message);
                }
            });
        }
    }

}
